import { ContentLanguageLabelModel } from '@fi-shared/models';
import { IFiChecklistCheckpointModel } from '@fi-shared/checklist';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { Injector } from '@angular/core';

export class CheckpointModel implements IFiChecklistCheckpointModel {
    Id: any;
    CreatedByUserId: any;
    CreatedByUserName: any;
    CreatedOn: any;
    ChangedByUserId: any;
    ChangedByUserName: any;
    ChangedOn: any;
    Name: any;
    Description: any;
    SortIndex: number;
    IsAttachmentMandatoryOk: boolean = undefined;
    IsAttachmentMandatoryNotOk: boolean = undefined;
    IsCommentMandatoryOk: boolean = undefined;
    IsCommentMandatoryNotOk: boolean = undefined;
    CheckPresence: boolean;
    NotificationRoleId: any;
    MediaBankFileReferences: IMediaBankFileReference[];
    Names: ContentLanguageLabelModel[] = [];
    Descriptions: ContentLanguageLabelModel[] = [];
    CheckPointSetting: {
        IsSetNotApplicable?: boolean;
        ChangedOn?: string;
        ChangedByUserName?: string;
        ChangedByUserId?: number;
    };
    Tag: {
        Id: number;
        Name: string;
    };
    TagId: number;
    $$fiCheckpointAnswer;
    $$notifyRoleChecked: boolean;

    constructor(data, injector: Injector) {
        if (!data) data = {};

        this.Id = undefined;
        this.CreatedByUserId = undefined;
        this.CreatedByUserName = undefined;
        this.CreatedOn = undefined;
        this.ChangedByUserId = undefined;
        this.ChangedByUserName = undefined;
        this.ChangedOn = undefined;
        this.Name = undefined;
        this.Description = undefined;
        this.SortIndex = 0;
        this.MediaBankFileReferences = [];
        this.IsAttachmentMandatoryOk = undefined;
        this.IsAttachmentMandatoryNotOk = undefined;
        this.IsCommentMandatoryOk = undefined;
        this.IsCommentMandatoryNotOk = undefined;
        this.NotificationRoleId = null;

        Object.assign(this, data);

        const contentLanguagesService = injector.get(ContentLanguagesService);
        contentLanguagesService.InitializeContentLanguagesArray(this.Names, data ? data.Names : []);
        contentLanguagesService.InitializeContentLanguagesArray(this.Descriptions, data ? data.Descriptions : []);
    }
}
